const isType = (value, type) => Object.prototype.toString.call(value) === `[object ${type}]`;

export default isType;
//# sourceMappingURL=isType.js.map